<page-title text="Supported Tokens | BitOasis" i18n-text="@@pageTitle.tokens"></page-title>
<page-meta description="" i18n-description="@@tokens.description"></page-meta>

<site-layout class="white full" [hideHeader]="isMobileWebView">
  <page-header
    contentTitle="Supported Tokens"
    contentDescription="In addition to Bitcoin and Ether, enjoy trading a comprehensive list of cryptocurrencies spanning across the Web3, DeFi, Metaverse and Smart contract spaces."
    i18n-contentTitle="@@tokens.header.title"
    i18n-contentDescription="@@tokens.header.info">
  </page-header>

  <main class="container">
    <search-crypto-component
      [items]="cryptos"
      [filteredFields]="['name', 'code']"
      (getFilteredData)="filterData($event)"
      [searchValue]="searchValue">
    </search-crypto-component>

    <div class="crypto-area">
      <loading *ngIf="loading" class="full" i18n="@@tokens.loading">Loading Data</loading>

      <error *ngIf="!loading && error" class="full">
        {{error}}
      </error>

      <ul class="list-items row" *ngIf="filteredCryptos && !loading && !error">
        <li class="list-item col-lg-3 col-md-4 col-6" *ngFor="let item of filteredCryptos">
          <p *ngIf="!item?.link" class="link">
            <ng-container *ngTemplateOutlet="coin; context: { item }"></ng-container>
          </p>
          <a *ngIf="item?.link" [routerLink]="['/prices', item?.link]" class="link">
            <ng-container *ngTemplateOutlet="coin; context: { item }"></ng-container>
          </a>
        </li>
      </ul>

      <div *ngIf="!filteredCryptos?.length && searchValue && !loading && !error" class="empty">
        <p i18n="@@tokens.search.nothing">Nothing found for “{{searchValue}}”</p>
        <button class="btn btn-link" (click)="clearSearchValue()" i18n="core2.currencyModal.empty.action">Clear search</button>
      </div>
    </div>
  </main>
</site-layout>
<site-footer *ngIf="!isMobileWebView"></site-footer>

<ng-template #coin let-item="item">
  <currency [currency]="item?.code"></currency>
  <div class="p-1"></div>
  <div class="info col">
    <div class="col">
      <div>{{item?.code}}</div>
      <div class="text-sm">{{item?.name}}</div>
    </div>
  </div>
</ng-template>
